import Barba from 'barba.js';

class BjzmBarbaTransition {

    constructor() {
        this.fullDuration = 1300;
        this.fadeDelay = this.fullDuration / 3;
        this.fadeDuration = this.fullDuration / 4;
        this.doFadeTransition();
    }

    doFadeTransition() {
        
        var fullDuration = this.fullDuration;
        var fadeDuration = this.fadeDuration;
        var fadeDelay = this.fadeDelay;

        var transEffect = Barba.BaseTransition.extend({
            start: function() {
                 Promise
                     .all([this.newContainerLoading, this.fadeOut()])
                     .then(this.fadeIn.bind(this));
            },
            fadeOut: function(something) {
                // $('body').addClass('transitioning');
                $('body').addClass('bjzm-transition-out');
                $('body').removeClass('bjzm-transition-in');
                var self = this;
                return new Promise(function(resolve, reject) {
                    window.setTimeout(() => {
                        // $('body').addClass('bjzm-transition-out');
                        // $(self.oldContainer).animate({ opacity: 0 }, fadeDuration).promise();
                        resolve();
                    }, fadeDelay);
                });
                    
            },
            fadeIn: function() {
               var _this = this;
               var $el = $(this.newContainer);

               $(this.oldContainer).hide();

               $el.css({
                  visibility : 'visible',
                  opacity : 0
              });

               $el.animate({ opacity: 1 }, 0, () =>  {
                   _this.done();
                   var transitionOutDelay = fadeDelay * 2;
                   setTimeout(() => {
                    // $('body').removeClass('transitioning');
                    $('body').removeClass('bjzm-transition-out');
                    $('body').addClass('bjzm-transition-in');
                    setTimeout(function(){
                      $('body').removeClass('bjzm-transition-in');
                    }, 800)
                   }, transitionOutDelay);
                    
               });
            }
         
        });
        Barba.Pjax.getTransition = function() {
            return transEffect;
        }
        Barba.Pjax.cacheEnabled = false;
        Barba.Pjax.start();

    }

}
module.exports = BjzmBarbaTransition;